/** @format */

import axios from "axios";
import { message } from "antd";

message.config({
  top: 60,
  duration: 3,
  maxCount: 3,
});
axios.defaults.withCredentials = true;

let parseParams = (data) => {
  try {
    var tempArr = [];
    for (var i in data) {
      var key = encodeURIComponent(i);
      var value = encodeURIComponent(data[i]);
      tempArr.push(key + "=" + value);
    }
    var urlParamsStr = tempArr.join("&");
    return urlParamsStr;
  } catch (err) {
    return "";
  }
};

const apphost = "http://101.132.24.213/znzmoappapi";
export const host = "/api";
// export const host = "http://192.168.31.212:81";//"http://127.0.0.1:81";
// export const host = "http://47.100.7.199:80";
export const commodityHost = "https://api.znzmo.com";
const simailarHost = "/api/imagesearch";
const tempHost = "";
// const linggan_host = `http://139.196.47.220${host}/znzgo`; // 正式
const linggan_host = `https://manager.znztv.com/api/znzgo`; // 测试
// const linggan_host = `http://40.72.102.222:8080`;

// 案例后台接口地址
// export const news_host = `http://120.55.167.92/manager`;//生产
export const news_host = `https://manager.znztv.com/manager`;//案例测试
// export const news_host = `http://139.217.230.126:8080/manager`;//没有证书改成http测试
// export const news_host = `http://172.16.100.16:82`;//李新本地联调地址



// const linggan_host = `${host}`;
axios.defaults.withCredentials = true;
const httpRequest = {
  post: async (api, param, headers) => {
    const result = await axios.post(api, param, headers);
    if (
      result.status == "401" ||
      !result.data.error ||
      result.data.error.errorCode == "90002" ||
      result.data.error.errorCode == "401"
    ) {
      window.location.href = "/login";
    }
    return result.data;
  },
  get: async (api, header) => {
    const ret = await axios.get(api, { ...header });
    if (
      ret.status == "401" ||
      !ret.data.error ||
      ret.data.error.errorCode == "90002" ||
      ret.data.error.errorCode == "401"
    ) {
      window.location.href = "/login";
    }
    return ret.data;
  },
};

export const detail = async function ({ physicalModelId, status, type }) {
  const result = await axios.get(
    tempHost +
    `/zhimo-admin/upload/detail.do?physicalModelId=${physicalModelId}&status=${status}`
  );
  // if (result.data.error.errorCode == 222) {
  //     message.success('数据有误！')
  //     return
  // }
  return result.data.data;
};

export const save = async function ({ UploadRequestEntity }) {
  const result = await axios.post(
    tempHost + "/zhimo-admin/upload/save.do",
    UploadRequestEntity
  );
  return result;
};

export const xiaSave = async function ({ XiaUploadRequestEntity }) {
  const result = await axios.post(
    "/zhimo-admin/xiaUpload/save.do",
    XiaUploadRequestEntity
  );
  return result;
};

// export const saveCommodityEdit = async function () {
//     const result = await axios.post('/upload/saveCommodityEdit.do', res)
//     console.log(result)
// };

export const notApprove = async function ({
  commodityId,
  physicalModelId,
  remark,
}) {
  let formData = new FormData();
  formData.append("commodityId", commodityId);
  formData.append("physicalModelId", physicalModelId);
  formData.append("remark", remark);
  const result = await axios.post(
    tempHost + `/zhimo-admin/upload/notApprove.do`,
    formData
  );
  return result;
};

export const updateSimilarImgStatus = async function ({ ids }) {
  let formData = new FormData();
  formData.append("ids", ids);
  const result = await axios.post(
    tempHost + `/zhimo-admin/upload/updateSimilarImgStatus.do`,
    formData
  );
  return result;
};

export const getSimilarImg = async function ({ mainImageUrl, type }) {
  const result = await axios.get(
    tempHost +
    `/zhimo-admin/upload/getSimilarImg.do?mainImageUrl=${mainImageUrl}`
  );
  return result.data.data;
};

export const getClassifyList = async function ({
  classifyId,
  classifyType,
  classifyLevel,
}) {
  const result = await axios.get(
    tempHost +
    `/zhimo-admin/upload/getClassifyList.do?classifyId=${classifyId}&classifyType=${classifyType}&classifyLevel=${classifyLevel}`
  );
  console.log(result);
};

export const getPropertyId = async function ({ classifyId, propertyType }) {
  const result = await axios.get(
    tempHost +
    `/zhimo-admin/upload/getPropertyId.do?classifyId=${classifyId}&propertyType=${propertyType}`
  );
  console.log(result);
};

export const xiaDetail = async function ({
  physicalModelId,
  status,
  type = "xia",
}) {
  const result = await axios.get(
    tempHost +
    `/zhimo-admin/xiaUpload/detail.do?physicalModelId=${physicalModelId}&status=${status}&type=${type}`
  );
  console.log(result);
  return result.data.data;
};

export const xiaNotApprove = async function ({
  commodityId,
  physicalModelId,
  remark,
}) {
  let formData = new FormData();
  formData.append("commodityId", commodityId);
  formData.append("physicalModelId", physicalModelId);
  formData.append("remark", remark);
  const result = await axios.post(
    tempHost + `/zhimo-admin/xiaUpload/notApprove.do`,
    formData
  );
  return result;
};

export const xiaSaveCommodityEdit = async function () {
  const res = {
    accountId: "9527",
    classifyId: 113850,
    commodityId: 4108620,
    commodityMemberLevel: 3,
    commodityPropertyValues: [
      {
        commoditypropertyvalueid: 4278309,
        propertyvalue: "简体中文111",
        commodityid: 4108620,
        propertyid: 211,
      },
      {
        commoditypropertyvalueid: 4278310,
        propertyvalue: "win XP",
        commodityid: 4108620,
        propertyid: 210,
      },
      {
        commoditypropertyvalueid: 4278311,
        propertyvalue: "win10",
        commodityid: 4108620,
        propertyid: 210,
      },
      {
        commoditypropertyvalueid: 4278312,
        propertyvalue: "其他",
        commodityid: 4108620,
        propertyid: 210,
      },
      {
        commoditypropertyvalueid: 4278313,
        propertyvalue: "win7",
        commodityid: 4108620,
        propertyid: 210,
      },
      {
        commoditypropertyvalueid: 4278314,
        propertyvalue: "win8",
        commodityid: 4108620,
        propertyid: 210,
      },
      {
        commoditypropertyvalueid: 4278315,
        propertyvalue: "win2003",
        commodityid: 4108620,
        propertyid: 210,
      },
      {
        commoditypropertyvalueid: 4278316,
        propertyvalue: "64位",
        commodityid: 4108620,
        propertyid: 209,
      },
      {
        commoditypropertyvalueid: 4278317,
        propertyvalue: "32位",
        commodityid: 4108620,
        propertyid: 209,
      },
    ],
    commodityType: 8,
    fileUrl: "https://user.file.znzmo.com/attachment_1558175350034.7z",
    level: 0,
    listImageUrl: "1558175379759_4518.png",
    physicalModelId: 4148730,
    price: 200,
    status: 5,
    summary: "",
    title: "测试00002",
  };

  const result = await axios.post("/xiaUpload/saveCommodityEdit.do", res);
  console.log(result);
};

// export const xiaNotApprove = async function ({commodityId, physicalModelId}) {
//     const res = {commodityId:commodityId, physicalModelId:physicalModelId};
//     const result = await axios.post(tempHost+`/zhimo-admin/xiaUpload/notApprove.do`,res);
//     console.log(result)
//     return result
// };

// export const xiaUpdateSimilarImgStatus = async function ({ids}) {
//     const res = {ids: ids};
//     const result = await axios.post(`/xiaUpload/updateSimilarImgStatus.do`,res);
//     console.log(result)
// };

// export const xiaGetSimilarImg = async function ({mainImageUrl, type}) {
//     const result = await axios.get(`/xiaUpload/getSimilarImg.do?mainImageUrl=${mainImageUrl}&type=${type}`);
//     console.log(result)
// };

export const xiaGetClassifyList = async function ({
  classifyId,
  classifyType,
  classifyLevel,
}) {
  const result = await axios.get(
    `/xiaUpload/getClassifyList.do?classifyId=${classifyId}&classifyType=${classifyType}&classifyLevel=${classifyLevel}`
  );
  console.log(result);
};

export const xiaGetPropertyId = async function ({ classifyId, propertyType }) {
  const result = await axios.get(
    `/xiaUpload/getPropertyId.do?classifyId=${classifyId}&propertyType=${propertyType}`
  );
  console.log(result);
};

export const getId = async function () {
  const result = await axios.get(tempHost + `/zhimo-admin/upload/getNextId.do`);
  return result.data.data;
};

export const getXiaId = async function () {
  const result = await axios.get(
    tempHost + `/zhimo-admin/xiaUpload/getNextId.do`
  );
  return result.data.data;
};

export const removeId = async function (id) {
  const result = await axios.get(
    tempHost + `/zhimo-admin/upload/removeId.do?physicalModelId=` + id
  );
  return result.data.data;
};

export const commodityTagList = async function (
  tag,
  skuId,
  page,
  pageSize,
  type
) {
  const result = await axios.get(
    tempHost +
    `/zhimo-admin/commodityTag/list.do?tag=` +
    tag +
    `&skuId=` +
    skuId +
    `&page=` +
    page +
    `&pageSize=` +
    pageSize +
    `&type=` +
    type
  );
  return result.data.data;
};

export const commodityTagSave = async function (json) {
  const result = await axios.post(
    tempHost + `/zhimo-admin/commodityTag/save.do`,
    json
  );
  return result.data;
};

export const commodityTagAdd = async function (json) {
  const result = await axios.post(
    tempHost + `/zhimo-admin/commodityTag/add.do`,
    json
  );
  return result.data;
};

export const commodityTagDelete = async function (tag) {
  const result = await axios.get(
    tempHost + `/zhimo-admin/commodityTag/delete.do?tag=` + tag
  );
  return result.data;
};

// app 后台接口

export const getSection = async function () {
  const result = await axios.get(`/api/discover/homelist`);
  return result.data.data;
};

export const getSinglehomeInfo = async function (confId) {
  const result = await axios.get(`/api/discover/single?confId=` + confId);
  return result.data;
};

export const pushDiscoverForm = async function (formData) {
  const result = await axios.post(`/api/discover/updateGroup`, formData);
  return result.data;
};

export const getAuthorInfo = async function (authorId) {
  const result = await axios.get(
    `/api/author/accountInfo?accountId=` + authorId
  );
  return result.data;
};

export const recommendItems = async function (formData) {
  const result = await axios.post(`/api/recommend/search`, formData);
  return result.data;
};

export const getItemDetail = async function (itemId) {
  const result = await axios.get(
    apphost + `/detail/itemdetail?itemId=` + itemId
  );
  return result.data;
};

/**
 * 作品统计api
 */
export const getAuthorStatisticsList = async function (formData) {
  const result = await axios.post(`/api/author/statisticlist`, formData);
  return result.data;
};

export const getAllClassifyList = async function () {
  const result = await axios.get(apphost + `/discover/classifyList`);
  return result.data.data;
};

export const pushRecommendItem = async function (recommendrequest) {
  const result = await axios.post(
    `/api/recommend/pushRecommendItem`,
    recommendrequest
  );
  return result.data;
};

export const getRecommendList = async function (param) {
  const result = await axios.post(`/api/recommend/list`, param);
  return result.data.data;
};

export const getDiscoverList = async function (param) {
  const result = await axios.post(`/api/discover/cardlist`, param);
  return result.data.data;
};

export const getStatisticList = async function (param) {
  const result = await axios.post(`/api/item/statisticlist`, param);
  return result.data.data;
};

export const getAllFloorList = async function () {
  const result = await axios.get(
    `/znzmo-inspiration-case-manage/floormanage/all`
  );
  return result.data.data;
};

export const getFloorDetail = async function (floorNum) {
  const result = await axios.get(
    `/znzmo-inspiration-case-manage/floormanage/detail?floorNum=` + floorNum
  );
  return result.data.data;
};

export const saveFloor = async function (param) {
  const result = await axios.post(
    `/znzmo-inspiration-case-manage/floormanage/save`,
    param
  );
  return result.data;
};

export const getAllTopicList = async function (page) {
  const result = await axios.get(
    `/znzmo-inspiration-case-manage/topicmanage/all?page=` +
    page +
    "&pageSize=10"
  );
  return result.data.data;
};

export const delTopic = async function (topicId) {
  const result = await axios.get(
    `/znzmo-inspiration-case-manage/topicmanage/del?topicId=` + topicId
  );
  return result.data;
};

export const updateTopic = async function (param) {
  const result = await axios.post(
    `/znzmo-inspiration-case-manage/topicmanage/udpate`,
    param
  );
  return result.data;
};

export const addTopic = async function (param) {
  const result = await axios.post(
    `/znzmo-inspiration-case-manage/topicmanage/add`,
    param
  );
  return result.data;
};
//3d xia 后台接口
export const getXiaCommodityList = async function (param) {
  const result = await axios.post(
    tempHost + `/zhimo-admin/xiauser/uploadifManage.do`,
    param
  );
  return result.data.data;
};
export const xiaUpdateLevel = async function (param) {
  const result = await axios.post(
    tempHost + `/zhimo-admin/xiauser/updateLevel.do`,
    param
  );
  return result.data;
};

export const getXiaCommodityListQuery = async function (param) {
  const result = await axios.post(
    tempHost + `/zhimo-admin/xiaUpload/getcommodityList.do`,
    param
  );
  return result.data.data;
};

export const getRefuse = async function (param) {
  const result = await axios.post(
    tempHost + "/zhimo-admin/xiaUpload/batchRefuse.do",
    param
  );
  return result;
};
//下架
export const updateXiaCommodityStatus2 = async function (param) {
  const result = await axios.post(
    tempHost + `/zhimo-admin/xiacommodity/checkStatusForOff.do`,
    param
  );
  return result.data;
};
//上架
export const updateXiaCommodityStatus4 = async function (param) {
  const result = await axios.post(
    tempHost + `/zhimo-admin/xiacommodity/getShield.do`,
    param
  );
  return result.data;
};
//清除收益
export const removeIncome = async function (param) {
  const result = await axios.post(
    tempHost + `/zhimo-admin/xiaNewcommodity/removeIncome.do`,
    param
  );
  return result.data;
};

export const xiagetClassifyList = async function (param) {
  const result = await axios.post(
    tempHost + `/zhimo-admin/xiacommodity/getClassify.do`,
    param
  );
  return result.data;
};

export const xiaRefluse = async function (param) {
  const result = await axios.post(
    tempHost + `/zhimo-admin/xiauser/uploadifWeiTongGuo.do`,
    param
  );
  return result.data;
};

export function getUrlParam(name, str) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  const r = str.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
}

//知末后台接口
export const getCommodityListQuery = async function (param) {
  const result = await httpRequest.post(
    tempHost + `/zhimo-admin/restcommodity/commodityList.do`,
    param
  );
  return result.data;
};

//下架
export const updateCommodityStatus2 = async function (param) {
  const result = await httpRequest.post(
    tempHost + `/zhimo-admin/commodity/checkStatusForOff.do`,
    param
  );
  return result;
};
//上架
export const updateCommodityStatus4 = async function (param) {
  const result = await httpRequest.post(
    tempHost + `/zhimo-admin/commodity/getShield.do`,
    param
  );
  return result;
};
//
export const getClassifyListadmin = async function (param) {
  const result = await httpRequest.post(
    tempHost + `/zhimo-admin/commodity/getClassify.do`,
    param
  );
  return result;
};
export const updateLevel = async function (param) {
  const result = await httpRequest.post(
    tempHost + `/zhimo-admin/upload/updatelevel.do`,
    param
  );
  return result;
};

//新后台审核
/*username: 10043
password: 12321*/
export const login = async function (param) {
  const result = await httpRequest.post(host + `/login`, param);
  return result;
};
export const getPermissions = async function (param) {
  const result = await httpRequest.get(linggan_host + `/permissions`, {
    headers: { userInfo: param },
  });
  return result;
};
//logout
export const logout = async function () {
  const result = await httpRequest.get(host + `/logout`);
  return result;
};
//登录状态接口
export const loginStatus = async function (type) {
  const result = await httpRequest.get(host + `/loginInfo`);
  return result;
};
//获取上传列表
export const uploadList = async function (param) {
  const result = await httpRequest.post(host + `/commodity/upload/list`, param);
  // return result.data;
  return result;
};
//获取商品列表
export const commodityListApi = async function (param) {
  const result = await httpRequest.post(host + `/commodity/manage/list`, param);
  return result.data;
};
//修改等级
export const modifyLevel = async function (param) {
  const result = await httpRequest.post(
    host + `/commodity/manage/updateLevel`,
    param
  );
  return result;
};
//修改商品列表
export const modifyPrice = async function (param) {
  const result = await httpRequest.post(
    host + `/commodity/manage/updatePrice`,
    param
  );
  return result;
};
//批量修改等级，价格

export const batchModifyLevelApi = async function (param) {
  const result = await httpRequest.post(
    host + `/commodity/manage/batchUpdateLevel`,
    param
  );
  return result;
};

export const batchModifyPriceApi = async function (param) {
  const result = await httpRequest.post(
    host + `/commodity/manage/batchUpdatePrice`,
    param
  );
  return result;
};

export const batchRefuseApi = async function (param) {
  const result = await httpRequest.post(
    host + `/commodity/manage/batchNotPass`,
    param
  );
  return result;
};

//批量通过
export const batchPassApi = async function (param) {
  const result = await httpRequest.post(
    host + `/commodity/upload/batchPass`,
    param
  );
  return result;
};

export const refuseReasonListApi = async function () {
  const result = await httpRequest.get(host + `/remark/list`);
  return result;
};

export const refuseApi = async function (param) {
  const result = await httpRequest.post(
    host + `/commodity/manage/notPass`,
    param
  );
  return result;
};

//获取审核详情
export const updateDetailApi = async function (commodityId) {
  const result = await httpRequest.get(
    host + `/commodity/upload/detail?commodityId=` + commodityId
  );
  return result;
};
//获取属性
export const getPropListApi = async function (propertyId) {
  const result = await httpRequest.get(
    host + `/property/valueList?propertyId=` + propertyId
  );
  return result.data;
};
//获取分类
export const getClassifyListApi = async function (commodityType) {
  const result = await httpRequest.get(
    host + `/classify/children?commodityType=` + commodityType
  );
  return result.data;
};

//获取相似图
/**
 * @param url
 * @param commodityType
 * @param page
 * @param pageSize
 * @returns {Promise<*>}
 */
export const getSimilarSearchApi = async function (
  url,
  commodityType,
  page,
  pageSize
) {
  const tagTypeMap = {
    0: 1,
    4: 4,
    5: 5,
    8: 5,
    2: 2,
    3: 1,
  };
  const result = await httpRequest.get(
    simailarHost +
    `/imagesearch/similar/searchUrl?url=${encodeURIComponent(url)}&tags=` +
    tagTypeMap[commodityType] +
    `&page=` +
    page +
    `&pageSize=` +
    pageSize
  );
  return result;
};

export const builderOptions = (classifyList) => {
  return classifyList.map((item) => {
    return {
      value: item.classifyId,
      label: item.name,
      children:
        item.childrenList.length > 0 ? builderOptions(item.childrenList) : null,
    };
  });
};

export const inspiration_builderOptions = (classifyList) => {
  return classifyList.map((item) => {
    return {
      value: item.classifyId,
      label: item.name,
      children:
        item.children != null
          ? inspiration_builderOptions(item.children)
          : null,
    };
  });
};

export const getClassifyArray = (classifyFamily) => {
  let classifyArray = new Array();
  if (
    classifyFamily &&
    classifyFamily.grandParentId &&
    classifyFamily.grandParentId != "0"
  ) {
    classifyArray.push(Number(classifyFamily.grandParentId));
  }
  if (
    classifyFamily &&
    classifyFamily.parentId &&
    classifyFamily.parentId != "0"
  ) {
    classifyArray.push(Number(classifyFamily.parentId));
  }
  if (
    classifyFamily &&
    classifyFamily.classifyId &&
    classifyFamily.classifyId != "0"
  ) {
    classifyArray.push(Number(classifyFamily.classifyId));
  }
  return classifyArray;
};
/**
 * 审核通过
 * @param param
 */
export const reviewPassApi = async function (param) {
  const result = await httpRequest.post(host + `/commodity/upload/pass`, param);
  return result;
};
export const getNextIdApi = async function () {
  const result = await httpRequest.get(host + `/commodity/upload/nextId`);
  return result;
};

export const delField4ReviewSubmit = (submitData) => {
  delete submitData.classifyIdArray;
  delete submitData.status;
  delete submitData.browseCount;
  delete submitData.classifyName;
  delete submitData.commodityMemberLevel;
  delete submitData.couponValue;
  delete submitData.createTime;
  delete submitData.downloadCount;
  delete submitData.fileLength;
  delete submitData.fileUrl;
  delete submitData.goldCoin;
  delete submitData.modelStyle;
  delete submitData.owner;
  delete submitData.reviewedBy;
  delete submitData.reviewedTime;
  delete submitData.thirdId;
  delete submitData.type;
  delete submitData.updateTime;
  delete submitData.version;
};

export const editSaveApi = async function (param) {
  const result = await httpRequest.post(host + `/commodity/manage/edit`, param);
  return result;
};

export const memberEveryCommodityListApi = async function (param) {
  const result = await httpRequest.post(
    host + `/api/everyDayCommodity/list`,
    param
  );
  return result;
};

export const searchwordReview = async function (param) {
  const result = await httpRequest.post(
    linggan_host + `/searchword/review`,
    param
  );
  return result;
};

export const memberEveryCommodityDetailApi = async function (param) {
  const result = await httpRequest.post(
    host + `/api/everyDayCommodity/detail`,
    param
  );
  return result;
};

export const commodityInfoApi = async function (param) {
  const result = await httpRequest.post(
    host + `/api/everyDayCommodity/commodityInfo`,
    param
  );
  return result;
};

export const updateStatusApi = async function (param) {
  const result = await httpRequest.post(
    host + `/commodity/manage/updateStatus`,
    param
  );
  return result;
};

// 新的批量下架接口
export const newUpdateStatusApi = async function (param) {
  const result = await httpRequest.post(
    host + `/commodity/manage/batchOffShelf`,
    param
  );
  return result;
};

export const memberEveryCommoditySave = async function (param) {
  const result = await httpRequest.post(
    host + `/api/everyDayCommodity/save`,
    param
  );
  return result;
};

export const inspiration_searchword_list = async function (
  page,
  size,
  status,
  column,
  sort
) {
  let url = linggan_host + "/searchword/list?page=" + page + "&size=" + size;
  if (status !== null) {
    url += "&status=" + status;
  }
  if (sort !== null && sort !== undefined) {
    url += "&sort=" + sort;
    if (column !== null && column !== undefined) {
      url += "&column=" + column;
    }
  }
  return await httpRequest.get(url);
};

export const inspiration_searchword_count = async function () {
  return await httpRequest.get(linggan_host + "/searchword/count");
};

export const inspitation_searchword_content = async function (params) {
  return await httpRequest.get(
    linggan_host +
    "/searchword/content?searchWordId=" +
    params.searchWordId +
    `&page=${params.page}&pageSize=${params.pageSize}`
  );
};

export const inspitation_searchword_noPass = async function (searchWordId) {
  const username = localStorage.getItem("username");
  return await axios.post(linggan_host + "/searchword/noPass", searchWordId, {
    headers: { "Content-Type": "application/json", userInfo: username },
  });
};

export const inspiration_searchword_handleTag = async function (param) {
  return await httpRequest.post(linggan_host + "/searchword/handleTag", param);
};

export const inspiration_Searchword_batchHandleTag = async function (param) {
  const username = localStorage.getItem("username");
  return await httpRequest.post(
    linggan_host + "/searchword/batchHandleTag",
    param,
    { headers: { userInfo: username } }
  );
};

export const inspiration_homepage_updateColl = async function (param) {
  return await httpRequest.post(
    linggan_host + "/homepage/addHomepageColl",
    param
  );
};

export const inspiration_homepage_updateColl_a = async function (param) {
  return await httpRequest.post(
    linggan_host + "/homepage/batchUpdateColl",
    param
  );
  // return await httpRequest.post('http://192.168.1.31:82/homepage/batchUpdateColl', param)
};

export const inspiration_getHotWord = async function (param) {
  return await httpRequest.get(
    `${linggan_host}/hotWord/hotword?${parseParams(param)}`
  );
};

export const SpiderInfo = async function (param) {
  return await httpRequest.post(`${host}/spiderInfo/all`, param, {
    headers: { "Content-Type": "application/json" },
  });
};

export const SpiderInfo_detail = async function (param) {
  return await httpRequest.post(`${host}/spiderInfo/detail`, param, {
    headers: { "Content-Type": "application/json" },
  });
};

export const SpiderInfo_add = async function (param) {
  return await httpRequest.post(`${host}/spiderInfo/add`, param, {
    headers: { "Content-Type": "application/json" },
  });
};

export const SpiderInfo_delete = async function (param) {
  return await httpRequest.get(
    `${host}/spiderInfo/delete?${parseParams(param)}`
  );
};

export const mainTable = async function (param) {
  return await httpRequest.post(`${host}/znzmoInfo/info`, param, {
    headers: { "Content-Type": "application/json" },
  });
};

export const mainCompetingTable = async function (param) {
  return await httpRequest.post(`${host}/znzmoInfo/competing`, param, {
    headers: { "Content-Type": "application/json" },
  });
};

export const mainCommodity = async function (param) {
  return await httpRequest.post(`${host}/znzmoInfo/commodity`, param, {
    headers: { "Content-Type": "application/json" },
  });
};

export const mainDownloadTable = async function (param) {
  return await httpRequest.post(`${host}/znzmoInfo/download`, param, {
    headers: { "Content-Type": "application/json" },
  });
};

export const threed2suMonitor = async function (param) {
  return await httpRequest.post(`${host}/znzmoInfo/3d2suMonitor`, param, {
    headers: { "Content-Type": "application/json" },
  });
};

export const mainBigTable = async function (param) {
  return await httpRequest.post(`${host}/znzmoInfo/market`, param, {
    headers: { "Content-Type": "application/json" },
  });
};

export const mainTableIncome = async function (param) {
  return await httpRequest.post(`${host}/znzmoInfo/income`, param, {
    headers: { "Content-Type": "application/json" },
  });
};

// 竞对模型监控表
export const getMonitorCompeteModel = async function (param) {
  return await httpRequest.post(`${host}/znzmoInfo/commodityCompete`, param, {
    headers: { "Content-Type": "application/json" },
  });
};

export const d3ListSpiderInfo = async function (param) {
  return await httpRequest.post(`${host}/xiaInfo/info`, param, {
    headers: { "Content-Type": "application/json" },
  });
};

export const d3ListSpiderInfoRevenue = async function (param) {
  return await httpRequest.post(`${host}/xiaInfo/income`, param, {
    headers: { "Content-Type": "application/json" },
  });
};

export const inspiration_getUpload = async function (param) {
  return await httpRequest.get(
    `${linggan_host}/uploadIns/collList?${parseParams(param)}`
  );
};

export const inspiration_imgListUpload = async function (param) {
  return await httpRequest.post(linggan_host + "/uploadIns/batchSave", param, {
    headers: { "Content-Type": "application/json" },
  });
};

export const inspiration_uploadLook = async function (param) {
  return await httpRequest.get(
    `${linggan_host}/uploadIns/content?${parseParams(param)}`
  );
};

export const inspiration_classifyTree = async function () {
  return await httpRequest.get(`${linggan_host}/classify/tree`);
};

export const inspiration_es_batchDelColl = async function (param) {
  return await axios.post(linggan_host + "/es/batchDelColl", param, {
    headers: { "Content-Type": "application/json" },
  });
};

export const inspiration_es_batchDelIns = async function (param) {
  return await axios.post(linggan_host + "/es/batchDelIns", param, {
    headers: { "Content-Type": "application/json" },
  });
};

export const popup_list = async function () {
  return await httpRequest.get(host + "/popup/list");
};

export const popup_updata = async function (param) {
  return await httpRequest.post(host + "/popup/update", param);
};

export const popup_delete = async function (id) {
  return await httpRequest.get(host + "/popup/delete?id=" + id);
};

export const popup_add = async function (param) {
  return await httpRequest.post(host + "/popup/add", param);
};

export const popup_updateSort = async function (param) {
  return await httpRequest.post(host + "/popup/updateSort", param);
};

export const vip_commodity_list = async function (
  pageSize,
  currentPage,
  type,
  param
) {
  return await httpRequest.get(
    `${host}/vip/commodity/list?pageSize=${pageSize}&page=${currentPage}&type=${type}${param}`
  );
};

export const vip_commodity_delete = async function (skuId) {
  return await httpRequest.post(`${host}/vip/commodity/delete?skuId=${skuId}`);
};
export const vip_commodity_delete2 = async function (date, type) {
  return await httpRequest.post(
    `${host}/vip/commodity/delete2?date=${date}&type=${type}`
  );
};

export const vip_commodity_findOne = async function (skuId, date) {
  return await httpRequest.get(
    `${host}/vip/commodity/findOne?skuId=${skuId}&date=${date}`
  );
};

export const vip_commodity_batchSave = async function (param) {
  return await httpRequest.post(`${host}/vip/commodity/batchSave`, param, {
    headers: { "Content-Type": "application/json" },
  });
};

export const vip_commodity_edit = async function (oldSkuId, newSkuId) {
  return await httpRequest.post(
    `${host}/vip/commodity/edit?from=${oldSkuId}&to=${newSkuId}`
  );
};

export const vip_transfer_list = async function (
  pageSize,
  currentPage,
  type,
  startDate,
  endDate,
  admin,
  skuId
) {
  return await httpRequest.get(
    `${host}/vip/transfer/list?page=${currentPage}&pageSize=${pageSize}&type=${type}&startDate=${startDate}&endDate=${endDate}&admin=${admin}&skuId=${skuId}`
  );
};

export const vip_transfer_batchSave = async function (param) {
  return await httpRequest.post(`${host}/vip/transfer/batchSave`, param);
};

export const getHotWord = async function (param) {
  return await httpRequest.get(
    `${host}/search/hotword/list?${parseParams(param)}`
  );
};

// 开放搜索
export const hotWordAutoData = async function (param) {
  return await httpRequest.get(
    `${host}/openSearch/totalCount?${parseParams(param)}`
  );
};

// 搜索热词新增
export const hotWordSave = async function (param) {
  return await httpRequest.post(`${host}/search/hotword/save`, param);
};

// 灵感搜索热词新增
export const inspiration_hotWordSave = async function (param) {
  return await httpRequest.post(`${linggan_host}/hotWord/save`, param);
};

// 3d侠VIP模型管理接口

export const thridDxia_vip_commodity_list = async function (
  pageSize,
  currentPage,
  type,
  param
) {
  if (type == -1) {
    return await httpRequest.get(
      `${host}/3dxia/vip/commodity/list?pageSize=${pageSize}&page=${currentPage}${param}`
    );
  }
  return await httpRequest.get(
    `${host}/3dxia/vip/commodity/list?pageSize=${pageSize}&page=${currentPage}&type=${type}${param}`
  );
};

// export const thridDxia_vip_commodity_delete = async function (skuId) {
//     return await httpRequest.post(`${host}/vip/commodity/delete?skuId=${skuId}`)
// };
export const thridDxia_vip_commodity_delete2 = async function (date, type) {
  return await httpRequest.post(
    `${host}/3dxia/vip/commodity/delete2?date=${date}&type=${type}`
  );
};

export const thridDxia_vip_commodity_batchSave = async function (param) {
  return await httpRequest.post(
    `${host}/3dxia/vip/commodity/batchSave`,
    param,
    { headers: { "Content-Type": "application/json" } }
  );
};

export const thridDxia_vip_commodity_findOne = async function (skuId, date) {
  return await httpRequest.get(
    `${host}/3dxia/vip/commodity/findOne?skuId=${skuId}&date=${date}`
  );
};

export const thridDxia_vip_commodity_edit = async function (
  oldSkuId,
  newSkuId
) {
  return await httpRequest.post(
    `${host}/3dxia/vip/commodity/edit?from=${oldSkuId}&to=${newSkuId}`
  );
};

export const thridDxia_album_list = async function (page, pageSize, param) {
  if (param) {
    return await httpRequest.get(
      `${host}/3dxia/album/list?page=${page}&pageSize=${pageSize}${param}`
    );
  } else {
    return await httpRequest.get(
      `${host}/3dxia/album/list?page=${page}&pageSize=${pageSize}`
    );
  }
};

// 初始化专辑

export const initAlbum = async function (param) {
  return await httpRequest.post(`${host}/3dxia/album/initAlbum`, param, {
    headers: { "Content-Type": "application/json" },
  });
};

// 3D侠模型标签接口
export const modelTagList = async function (page, pageSize, param) {
  if (param) {
    return await httpRequest.get(
      `${host}/3dxia/vip/transfer/list?page=${page}&pageSize=${pageSize}${param}`
    );
  } else {
    return await httpRequest.get(
      `${host}/3dxia/vip/transfer/list?page=${page}&pageSize=${pageSize}`
    );
  }
};

// 版本转换
export const transferVersion = async function (param) {
  return await httpRequest.post(`${host}/3dxia/vip/transfer/batchSave`, param);
};

// 专辑启用/禁用、编辑
export const ableAlbum = async function (param) {
  return await httpRequest.post(`${host}/3dxia/album/saveAlbum`, param, {
    headers: { "Content-Type": "application/json" },
  });
};

// 批量新增专辑商品
export const batchSaveCommodity = async function (param) {
  return await httpRequest.post(
    `${host}/3dxia/album/batchSaveCommodity`,
    param,
    { headers: { "Content-Type": "application/json" } }
  );
};

// 获取专辑的所有商品
export const getAlbumCommodityList = async function (albumId) {
  return await httpRequest.get(
    `${host}/3dxia/album/content?albumId=${albumId}`
  );
};

// 修改专辑中的商品
export const updateCommodity = async function (param) {
  return await httpRequest.post(`${host}/3dxia/album/edit`, param, {
    headers: { "Content-Type": "application/json" },
  });
};

// 删除专辑中的商品
export const deleteCommodity = async function (param) {
  return await httpRequest.post(`${host}/3dxia/album/delCommodity`, param);
};

// 查询图集列表
export const getCollListInAtlas = async function (param) {
  return await httpRequest.get(
    `${linggan_host}/coll/list?page=${param.page}&size=20&collId=${param.collId}&firstClassifyId=${param.firstClassifyId}&secondClassifyId=${param.secondClassifyId}&thirdClassifyId=${param.thirdClassifyId}&status=${param.status}`
  );
};

// 灵感集下面的灵感列表
export const getContentListInAtlas = async function (collId) {
  return await httpRequest.get(
    `${linggan_host}/uploadIns/content?collId=${collId}`
  );
};

// 查询灵感图列表
export const getInsListInAtlas = async function (param) {
  return await httpRequest.get(
    `${linggan_host}/ins/list?page=${param.page}&size=50&insId=${param.insId}&firstClassifyId=${param.firstClassifyId}&secondClassifyId=${param.secondClassifyId}&thirdClassifyId=${param.thirdClassifyId}`
  );
};

// 查询标签列表
export const getTagList = async function (param) {
  let link = `${linggan_host}/tag/list?page=${param.page}&size=50&status=${param.status}`;
  if (param.column) {
    link += `&column=${param.column}&sort=${param.sort}`;
  }
  console.log("link", link);
  return await httpRequest.get(link);
};

// 不同标签的数目
export const getTagCount = async function () {
  return await httpRequest.get(`${linggan_host}/tag/count`);
};

// 根据标签获取内容
export const getTagContent = async function (params) {
  return await httpRequest.get(
    `${linggan_host}/tag/content?tagReviewId=${params.tagReviewId}&page=${params.page}&pageSize=${params.pageSize}`
  );
};

// 删除灵感图
export const getTagDelIns = async function ({ word, insId }) {
  return await httpRequest.post(
    `${linggan_host}/tag/delInsTag?word=${word}&insId=${insId}`
  );
};

// 全部下架
export const takeoffAll = async function (tagReviewId) {
  return await httpRequest.get(
    `${linggan_host}/tag/takeoffAll?tagReviewId=${tagReviewId}`
  );
};

// 完成审核标签
export const getTagFinish = async function (tagReviewId) {
  return await httpRequest.get(
    `${linggan_host}/tag/finish?tagReviewId=${tagReviewId}`
  );
};

// 获取题图关键词
export const getTietuKeyword = async function (param) {
  return await httpRequest.post(
    `${host}/textureKeyword/list?page=${param.page}&pageSize=${param.pageSize}&keyword=${param.keyword}&type=${param.type}&status=${param.status}`
  );
};

// 停用启用关键词
export const toggleTietuStatus = async function (param) {
  return await httpRequest.post(
    `${host}/textureKeyword/stop?id=${param.id}&status=${param.status}`
  );
};

// 增加关键词
export const addTietuKeyword = async function (param) {
  return await httpRequest.post(
    `${host}/textureKeyword/add?keyword=${param.keyword}&type=${param.type}&status=${param.status}&link=${param.link}&sort=${param.sort}`
  );
};

// 编辑关键词
export const editTietuKeyword = async function (param) {
  return await httpRequest.post(
    `${host}/textureKeyword/update?id=${param.id}&keyword=${param.keyword}&type=${param.type}&status=${param.status}&link=${param.link}&sort=${param.sort}`
  );
};

//  词条分类接口

// 列表查询接口
export const getCategoryTableList = async function (param) {
  return await httpRequest.post(`${host}/category/review/list`, param);
};

// 刷新字条分类
export const refreshList = async function (param) {
  return await httpRequest.post(`${host}/category/review/refresh`, param);
};

// 获取单个等级的词条集合
export const getSingleClassifyList = async function (param) {
  return await httpRequest.get(
    `${host}/category/review/terms?type=${param.type}&level=${param.level}&parentId=${param.parentId}`
  );
};

// 获取分类商品
export const getCommodityList = async function (param) {
  return await httpRequest.post(`${commodityHost}/commodity/list`, param);
};

// 调整分类接口
export const setNewClassify = async function (param) {
  return await httpRequest.post(`${host}/category/review/commodity`, param);
};

// 分类审核接口
export const finish = async function (param) {
  return await httpRequest.post(`${host}/category/review/finish`, param);
};

// 重置审核列表接口
export const resetStatus = async function (param) {
  return await httpRequest.post(`${host}/category/review/reset`, param);
};

// 首页

// 导航栏下拉区域
export const getNavDropList = async function (param) {
  if (param.type) {
    return await httpRequest.get(
      `${host}/homepage/adv/list?type=${param.type}`
    );
  } else {
    return await httpRequest.get(`${host}/homepage/adv/list`);
  }
};
export const updateNavDropItem = async function (param) {
  return await httpRequest.post(`${host}/homepage/adv/update`, param);
};

// 频道集市区域
export const getChannelMarketList = async function (param) {
  if (param.type) {
    return await httpRequest.get(
      `${host}/homepage/channelCollection/list?type=${param.type}`
    );
  } else {
    return await httpRequest.get(`${host}/homepage/channelCollection/list`);
  }
};
export const updateChannelMarketItem = async function (param) {
  return await httpRequest.post(
    `${host}/homepage/channelCollection/update`,
    param
  );
};

// 频道楼层区域
export const getChannelFloorList = async function (param) {
  if (param.type) {
    return await httpRequest.get(
      `${host}/homepage/floorContent/list?type=${param.type}`
    );
  } else {
    return await httpRequest.get(`${host}/homepage/floorContent/list`);
  }
};
export const updateChannelFloorItem = async function (param) {
  return await httpRequest.post(`${host}/homepage/floorContent/update`, param);
};

// 楼层标题文案
export const getFloorCopywritingList = async function (param) {
  if (param.type) {
    return await httpRequest.get(
      `${host}/homepage/floor/list?type=${param.type}`
    );
  } else {
    return await httpRequest.get(`${host}/homepage/floor/list`);
  }
};
export const updateFloorCopywritingItem = async function (param) {
  return await httpRequest.post(`${host}/homepage/floor/update`, param);
};

// 频道文案
export const getChannelCopywritingList = async function (param) {
  if (param.type) {
    return await httpRequest.get(
      `${host}/homepage/floorChannel/list?type=${param.type}`
    );
  } else {
    return await httpRequest.get(`${host}/homepage/floorChannel/list`);
  }
};
export const updateChannelCopywritingItem = async function (param) {
  return await httpRequest.post(`${host}/homepage/floorChannel/update`, param);
};

// 用户名片
export const getUsercardList = async function (param) {
  if (param.type) {
    return await httpRequest.get(
      `${host}/homepage/creator/list?type=${param.type}`
    );
  } else {
    return await httpRequest.get(`${host}/homepage/creator/list`);
  }
};
export const updateUsercardItem = async function (param) {
  return await httpRequest.post(`${host}/homepage/creator/update`, param);
};

// 软件、插件排行榜
export const getPluginList = async function (param) {
  if (param.type) {
    return await httpRequest.get(
      `${host}/homepage/soft/list?softType=${param.type}`
    );
  } else {
    return await httpRequest.get(`${host}/homepage/soft/list`);
  }
};
export const updatePlugingItem = async function (param) {
  return await httpRequest.post(`${host}/homepage/soft/update`, param);
};

// 导航下拉分类
export const getNavClassifyList = async function (param) {
  if (param.type) {
    if (param.parentId) {
      return await httpRequest.get(
        `${host}/homepage/classify/list?type=${param.type}&parentId=${param.parentId}`
      );
    }
    return await httpRequest.get(
      `${host}/homepage/classify/list?type=${param.type}`
    );
  } else {
    return await httpRequest.get(`${host}/homepage/classify/list`);
  }
};
export const updateNavClassifyItem = async function (param) {
  return await httpRequest.post(`${host}/homepage/classify/update`, param);
};

// 首页--灵感图集
export const getPingList = async function (param) {
  return await httpRequest.get(`${host}/homepage/insCollection/list`);
};
export const updatePingItem = async function (param) {
  return await httpRequest.post(`${host}/homepage/insCollection/update`, param);
};

// 搜索词
// 按频道、搜索词搜索
export const getSearchResults = async function (param) {
  return await httpRequest.post(`${commodityHost}/commodity/list`, param);
};

// 确认修改
export const changeSearchClassify = async function (param) {
  return await httpRequest.post(
    `${host}/search/review/commodity?classifyId=${param.classifyId}&skuId=${param.skuId}&title=${param.title}&level=${param.level}&styleValue=${param.styleValue}`
  );
};
// 恢复重置
export const resetSearchClassify = async function (param) {
  return await httpRequest.post(
    `${host}/search/review/revert?skuId=${param.skuId}`
  );
};

// 推荐专区合辑管理
export const getRecommendAreaCollectionList = async function (param) {
  return await httpRequest.get(
    `${host}/recommendArea/listColl?${parseParams(param)}`
  );
};

// 切换推荐专区合辑状态（合辑和楼层公用）
export const switchStatus = async function (param) {
  return await httpRequest.get(
    `${host}/recommendArea/switchStatus?recommendAreaId=${param.id}`
  );
};

// 新增专区（合辑和楼层公用）
export const addArea = async function (param) {
  return await httpRequest.post(`${host}/recommendArea/save`, param);
};

// 更新专区（合辑和楼层公用）
export const updateArea = async function (param) {
  return await httpRequest.post(`${host}/recommendArea/update`, param);
};

// 合辑列表
export const getCollectionList = async function (param) {
  return await httpRequest.get(
    `${host}/recommendArea/listAlbum?${parseParams(param)}`
  );
};

// 增加专辑
export const addCollection = async function (param) {
  return await httpRequest.post(`${host}/recommendArea/saveAlbum`, param);
};

// 查询label
export const labelCollection = async function (param) {
  // return await httpRequest.get(`${host}/recommendArea/label`, param)
  return await httpRequest.get(
    `${host}/recommendArea/label?type=${param.type}`,
    param
  );
};

// 编辑专辑
export const updateCollection = async function (param) {
  return await httpRequest.post(`${host}/recommendArea/updateAlbum`, param);
};

// 停用启用专辑
export const switchCollection = async function (param) {
  return await httpRequest.get(
    `${host}/recommendArea/switchAlbum?albumId=${param.albumId}`
  );
};

// 推荐专区楼层管理
export const getRecommendAreaFloorList = async function (param) {
  return await httpRequest.get(
    `${host}/recommendArea/listFloorColl?${parseParams(param)}`
  );
};

// 标签专区列表
export const getRecommendAreaName = async function (param) {
  return await httpRequest.get(
    `${host}/recommendArea/listAreaName?${parseParams(param)}`
  );
};

// 标签专区信息
export const getRecommendAreaLabelInfo = async function (param) {
  return await httpRequest.get(
    `${host}/recommendArea/listLabelInfo?${parseParams(param)}`
  );
};

// 标签专区更新
export const getRecommendAreaUpdateLabel = async function (param) {
  return await httpRequest.post(`${host}/recommendArea/updateLabelInfo`, param);
};

// 标签专区新增
export const getRecommendAreaSaveLabel = async function (param) {
  return await httpRequest.post(`${host}/recommendArea/saveLabelInfo`, param);
};

// 列表
export const getFloorList = async function (param) {
  return await httpRequest.get(
    `${host}/recommendArea/listFloor?${parseParams(param)}`
  );
};

// 停用启用楼层
export const switchFloor = async function (param) {
  return await httpRequest.get(
    `${host}/recommendArea/switchFloor?floorId=${param.floorId}`
  );
};

// 增加楼层
export const addFloor = async function (param) {
  return await httpRequest.post(`${host}/recommendArea/saveFloor`, param);
};

// 编辑楼层
export const updateFloor = async function (param) {
  return await httpRequest.post(`${host}/recommendArea/updateFloor`, param);
};
// 刷新搜索管理缓存
export const handleRefresh = async function (param) {
  return await httpRequest.post(
    `${host}/search/review/refresh?${parseParams(param)}`
  );
};

// 积分贴图

// 获取列表
export const getIntegralModelList = async function (
  pageSize,
  currentPage,
  type,
  startDate,
  endDate,
  admin,
  skuId
) {
  return await httpRequest.get(
    `${host}/points/transfer/list?page=${currentPage}&pageSize=${pageSize}&type=${type}&startDate=${startDate}&endDate=${endDate}&admin=${admin}&skuId=${skuId}`
  );
};
// 转换
export const integral_transfer_batchSave = async function (param) {
  return await httpRequest.post(
    `${host}/points/transfer/batchSave
    `,
    param
  );
};

// SU限时免费专区
export const getSuFreeList = async function (pageSize, currentPage, param) {
  return await httpRequest.get(
    `${host}/limitFree/commodity/list?pageSize=${pageSize}&pageNum=${currentPage}&type=${4}${param}`
  );
};

export const deleteSuFreeItem = async function (startDateStr, classifyName) {
  return await httpRequest.get(
    `${host}/limitFree/commodity/delete?startDateStr=${startDateStr}&classifyName=${classifyName}`
  );
};

export const editSuFreeItem = async function (param) {
  return await httpRequest.post(`${host}/limitFree/commodity/updateSU`, param);
};

export const addSuFreeItem = async function (param) {
  return await httpRequest.post(`${host}/limitFree/commodity/saveSU`, param);
};

// 获取模型来源

export const reqModelFrom = async function (id) {
  return await httpRequest.post(
    `${host}/search/review/accountType?skuId=${id}`
  );
};

// 获取模型属性列表

export const reqModelProperties = async function ({ type }) {
  return await httpRequest.get(
    `${host}/commodity/property/listPropertyId?type=${type}`
  );
};

// 获取模型属性标签值
export const reqModelPropertyValue = async function ({ propertyId }) {
  return await httpRequest.get(
    `${host}/commodity/property/listPropertyValue?propertyId=${propertyId}`
  );
};

export const changeModelProperty = async function (data) {
  return await httpRequest.post(`${host}/commodity/property/updateBatch`, data);
};

export const reqIsBrandModel = async function ({ commodityId }) {
  return await httpRequest.get(
    `${host}/commodity/property/brandModel?skuId=${commodityId}`
  );
};

// 判断是否是植物
export const reqIsPlant = async function ({ skuId }) {
  return await httpRequest.get(`${host}/classify/isPlant?skuId=${skuId}`);
};

// 收益清除列表
export const reqIncomeList = async function (data) {
  return await httpRequest.post(`${host}/income/list`, data);
};

// 清除收益
export const reqCleanIncome = async function (data) {
  return await httpRequest.post(`${host}/income/clean`, data);
};

// 返还收益
export const reqBackProfit = async function (data) {
  return await httpRequest.get(
    `${host}/income/back?orderId=${data.orderId}`,
    data
  );
};

// 批量返还收益
export const reqBatchBackProfit = async function (data) {
  return await httpRequest.post(`${host}/income/backBatch`, data);
};

// 悬赏模型列表
export const reqRewardList = async function (data) {
  return await httpRequest.post(`${host}/reward/list`, data);
};

// 悬赏模型classify
export const rewordClassifyList = async function (type) {
  return await httpRequest.get(`${host}/reward/listClassify?type=${type}`);
};

// 封禁单个id接单
export const banRewordId = async function (data) {
  return await httpRequest.get(
    `${host}/reward/ban?accountId=${data.id}&days=${data.days}`
  );
};

// 封禁多个id接单
export const banRewordIds = async function (data) {
  return await httpRequest.post(`${host}/reward/banBatch`, data);
};

// 取消单个任务
export const cancelTask = async function (data) {
  return await httpRequest.post(`${host}/reward/cancel`, data);
};

// 取消多个任务
export const cancelTasks = async function (data) {
  return await httpRequest.post(`${host}/reward/cancelBatch`, data);
};

// 悬赏后台 根据 id 获取对应的悬赏任务
export const getRewardDetail = async function (data) {
  return await httpRequest.get(`${host}/reward/detail?submitId=${data}`);
};

// 悬赏后台，悬赏任务不通过
export const rewardNotPass = async function (data) {
  return await httpRequest.post(`${host}/reward/notPass`, data);
};

export const rewardPass = async function (data) {
  return await httpRequest.post(`${host}/reward/pass`, data);
};

// 灵感后台 ksm 知识体系维护 获取 10 个候选词
export const getListRecommendTagWorld = async function (data) {
  return await httpRequest.get(
    `${linggan_host}/knowledge/manger/listRecommendTagWord?input=${data}`
  );
};

// 灵感后台 ksm 知识体系维护 获取父级
export const getListParentFilter = async function (data) {
  return await httpRequest.get(
    `${linggan_host}/knowledge/manger/listParentFilter?tagWord=${data}`
  );
};

// 灵感后台 ksm 知识体系维护 获取知识体系词
export const getListKnowledge = async function (data) {
  return await httpRequest.post(
    `${linggan_host}/knowledge/manger/listKnowledge`,
    data
  );
};

// 灵感后台 检查用户新增的知识体系词
export const checkAddKnowledge = async function (data) {
  return await httpRequest.post(
    `${linggan_host}/knowledge/manger/checkAddKnowledge`,
    data
  );
};

// 灵感后台 添加知识体系词
export const addKnowledge = async function (data) {
  const username = localStorage.getItem("username");
  return await httpRequest.post(
    `${linggan_host}/knowledge/manger/addKnowledge`,
    data,
    { headers: { userInfo: username } }
  );
};

// 灵感后台 添加近义词
export const addKnowledgeSame = async function (data) {
  const username = localStorage.getItem("username");
  return await httpRequest.post(
    `${linggan_host}/knowledge/manger/addKnowledgeSame`,
    data,
    { headers: { userInfo: username } }
  );
};

// 搜索相似图片
export const searchListSimilar = async function (data) {
  return await httpRequest.post(`${host}/imagesearchv2/listSimilar`, data);
};

// 相似图打标签
export const similarAddTag = async function (data) {
  return await httpRequest.post(`${host}/imagesearchv2/mark/add`, data);
};

// 新 SU 后台 根据 sourceType 获得
export const suControllerList = async function (data) {
  return await httpRequest.get(`${host}/homepage/su/list?sourceType=${data}`);
};

// 新 SU 后台，获取细节
export const suGetDetail = async function (data) {
  return await httpRequest.get(`${host}/homepage/su/detail?expandId=${data}`);
};

// 新 SU 后台，修改
export const suEdit = async function (data) {
  return await httpRequest.post(`${host}/homepage/su/edit`, data);
};

// 爬取词图片
export const crawlRecord = async function (data) {
  return await httpRequest.post(`${linggan_host}/crawlRecord/list`, data);
};

// 爬取词图片统计
export const crawlRecordSum = async function (data) {
  return await httpRequest.post(`${linggan_host}/crawlRecord/sum`, data);
};

export const caseHomepageRightList = async function (data) {
  return await httpRequest.post(
    `${linggan_host}/case/caseHomepageRightList`,
    data
  );
};

export const updateCaseHomepageRight = async function (data) {
  return await httpRequest.get(
    `${linggan_host}/case/updateCaseHomepageRight?id=${data.id}&caseId=${data.caseId}&word=${data.word}`
  );
};

export const caseBanner = async function (data) {
  return await httpRequest.get(`${news_host}/homepageBanner`);
};

export const updateCaseBanner = async function (data) {
  return await httpRequest.post(`${news_host}/updateHomepageBanner`, data);
};
export const updateDailyRecommend = async function (data) {
  return await httpRequest.post(
    `${linggan_host}/homepage/dailyRecommend`,
    data
  );
};

export const homeClearRedis = async function () {
  return await httpRequest.post(`${linggan_host}/homepage/clearRedis`);
};

export const caseClearRedis = async function () {
  return await httpRequest.post(`${linggan_host}/case/clearRedis`);
};

export const caseReleaseTime = async function () {
  return await httpRequest.get(`${linggan_host}/case/popular/releaseTime`);
};

export const caseAddPopularCase = async function (data) {
  return await httpRequest.post(
    `${linggan_host}/case/popular/addPopularCase`,
    data
  );
};

// 首页知末图窗楼层
export const getHomePicWindow = async function (data) {
  return await httpRequest.get(`${host}/homepage/list?sourceType=15`);
};

// 首页知末图窗楼层保存
export const saveHomePicWindow = async function (data) {
  return await httpRequest.post(`${host}/homepage/edit`, data);
};

// 知末弹窗公告 - 获取
export const getNotice = async (infoId) => {
  return await httpRequest.get(
    `${host}/popup/notice/listDetail?infoId=${infoId}`
  );
};

// 知末弹窗公告 - 新增
export const addNotice = async (data) => {
  return await httpRequest.post(`${host}/popup/notice/addDetail`, data);
};

// 知末弹窗公告 - 切换启用停用
export const switchUse = async (id) => {
  return await httpRequest.get(
    `${host}/popup/notice/switchDetail?detailId=${id}`
  );
};

// 知末弹窗公告 - 修改公告
export const modifyNotice = async (data) => {
  return await httpRequest.post(`${host}/popup/notice/updateDetail`, data);
};

// 商品批量修改
export const commodityBatchModifyGetOption = async (type) => {
  return await httpRequest.get(`${host}/commodity/batch/option?type=${type}`);
};

// 商品批量修改
export const commodityBatchModifyPrice = async (data) => {
  return await httpRequest.post(`${host}/commodity/batch/price`, data);
};

// 商品批量等级
export const commodityBatchModifyLevel = async (data) => {
  return await httpRequest.post(`${host}/commodity/batch/level`, data);
};

// 商品批量日期
export const commodityBatchModifyDate = async (data) => {
  return await httpRequest.post(`${host}/commodity/batch/date`, data);
};

// 3d 频道首页的 api
export const get3DHomePageDetail = async function (sourceType, type) {
  return await httpRequest.get(
    `${host}/homepage/3d/list?sourceType=${sourceType}&type=${type}`
  );
};

// 3d 频道首页软件上传
export const edit3DHomePageDetail = async function (data) {
  return await httpRequest.post(`${host}/homepage/3d/edit`, data);
};
// 友情链接管理 - 获取友情链接
export const getLinks = async (data) => {
  return await httpRequest.post(`${host}/friendlylink/list`, data);
};

// 友情链接管理 - 添加友情链接
export const addLinks = async (data) => {
  return await httpRequest.post(`${host}/friendlylink/add`, data);
};

// 友情链接管理 - 修改友情链接
export const modifyLinks = async (data) => {
  return await httpRequest.post(`${host}/friendlylink/update`, data);
};

// 友情链接管理 - 删除友情链接
export const deleteLinks = async (data) => {
  return await httpRequest.get(`${host}/friendlylink/delete?id=data`);
};
// 商品下架
export const banCommodity = async (data) => {
  return await httpRequest.get(
    `${host}/category/review/offShelf?skuId=${data}`
  );
};

// 审核打标列表页
export const getAuditMarkingList = async (data) => {
  return await httpRequest.post(`${linggan_host}/handle/group/list`, data);
};

// 审核打标列表页审核人今日数据
export const auditMarkingTodayPersonnelInformation = async (data) => {
  return await httpRequest.get(`${linggan_host}/handle/personal/data`, {
    headers: { userInfo: data },
  });
};

// 审核打标每组图片列表
export const getAuditMarkingGroupIns = async (id, needsTag, needStar, finishStatus) => {
  return await httpRequest.get(
    `${linggan_host}/handle/ins/list?groupId=${id}&needTags=${needsTag}&needStar=${needStar}&finishStatus=${finishStatus ? finishStatus : 0}`
  );
};

// 审核打标不通过
export const auditMarkingNoPassGroup = async (data, userInfo) => {
  return await httpRequest.post(
    `${linggan_host}/handle/nopass/batch`,
    // {
    // 	groupId,
    // 	idList,
    // },
    data,
    {
      headers: { userInfo: userInfo },
    }
  );
};

// 审核打标 根据关键词模糊搜索标签
export const auditMarkingGetTagsList = async (keyword) => {
  return await httpRequest.get(
    `${linggan_host}/handle/tags/list?keyword=${keyword}`
  );
};

// 审核打标，评星级
export const auditMarkingEvaluate = async (data, header) => {
  return await httpRequest.post(`${linggan_host}/handle/star/rate`, data, {
    headers: { userInfo: header },
  });
};

// 审核打标，获取标签页标签list
export const getAuditMarkingTagsList = async () => {
  return httpRequest.get(`${linggan_host}/handle/tag/style`);
};

// 审核打标，打标签接口
export const auditMarkingTagging = async (data, header) => {
  return httpRequest.post(`${linggan_host}/handle/tagging`, data, {
    headers: { userInfo: header },
  });
};

// 获取推荐标签
export const aditMarkingTaggingRecommendTaggs = async (data) => {
  return httpRequest.get(
    `${linggan_host}/handle/recommendTag/list?parentId=${data.parentId}&type=${data.type}`
  );
};

// 新增临时标签
export const aditMarkingTaggingAdd = async (data) => {
  return httpRequest.post(`${linggan_host}/handle/tempTag/add`, data);
};

// 获取新增标签
export const aditMarkingTaggingGetAddedTaggs = () => {
  return httpRequest.get(`${linggan_host}/handle/tempTag/list`);
};

// 审核打标 检查临时标签
export const aditMarkingTaggingCheckTag = (data) => {
  return httpRequest.get(`${linggan_host}/handle/tempTag/check?word=${data}`);
};

// 删除案例
export const deleteCaseByIds = async (param) => {
  return await httpRequest.post(
    "https://manager.znztv.com/manager/case/manager/deleteBatch",
    param,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

// 重新上架id
export const reshelfCaseByIds = async (data) => {
  const username = localStorage.getItem("username");
  return await httpRequest.post(
    `${news_host}/case/manager/shelvesBatch`,
    data,
    {
      headers:{userInfo:username}
    }
  )
}
// 案例文本翻译
export const translateCase = async (data) => {
  const username = localStorage.getItem("username");
  return await httpRequest.get(
    `${news_host}/case/manager/translateCase?caseId=${data}`,
    data,
    {
      headers:{userInfo:username}
    }
  )
}

// 获取下一个案例id
export const getNextCaseId = async () =>{
  const username = localStorage.getItem("username");
  return await httpRequest.get(`${news_host}/case/classify/nextId`,
  {headers:{
    userInfo:username
  }});
}
// 根据设计师ID获取设计师姓名
export const getDesignersByIds = async (data) =>{
  const username = localStorage.getItem("username");
  return await httpRequest.post(`${news_host}/designer/queryCaseDesignMasterByPropertyIds`,
  data,
  {headers:{
    userInfo:username
  }});
}

//案例日报显示设置
export const showHomePage = async (data) => {
  return await httpRequest.post(`${news_host}/case/manager/showHomePage`, data);
};
// 案例后台
export const changeCaseCover = async (data) => {
  return await httpRequest.post(`${news_host}/case/manager/update`, data);
};

// 案例后台，爬取
export const crawlBehance = async (data) => {
  return await httpRequest.post(`${news_host}/spider/behance`, data);
};
// 案例后台，人工爬取behance结果
export const behanceList = async (page, pageSize, orderType) => {
  return httpRequest.get(`${news_host}/spider/behance/list?page=${page}&pageSize=${pageSize}&orderType=${orderType}`);
};
// 案例后台，案例分类列表
export const classifyList = async () => {
  return httpRequest.get(`${news_host}/case/classify/list`);
};

// 案例后台， 案例 新增标语
export const sloganAdd = async (data) => {
  return await httpRequest.post(`${news_host}/case/slogan/add`, data);
};
// 案例后台， 案例 更新标语
export const sloganUpdate = async (data) => {
  return await httpRequest.post(`${news_host}/case/slogan/update`, data);
};

// 案例后台，案例分类 所有标语列表
export const sloganList = async (orderType, secondClassifyId) => {
  return httpRequest.get(`${news_host}/case/slogan/list?orderType=${orderType}&secondClassifyId=${secondClassifyId}`);
};

// 案例后台，案例分类 新增弹窗标语下拉框列表
export const selectSloganList = async () => {
  return httpRequest.get(`${news_host}/slogan/list`);
};
// 案例后台，案例分类 标语启用/弃用
export const sloganStatust = async (sloganId, status) => {
  return httpRequest.get(`${news_host}/case/slogan/status?sloganId=${sloganId}&status=${status}`);
};

// 案例后台 来源网站list
export const websiteList = async () => {
  return httpRequest.get(`${news_host}/case/website/list`);
};

// 案例后台 案例分类审核列表
export const classifyCheckList = async (data) => {
  const username = localStorage.getItem("username");
  return httpRequest.post(`${news_host}/case/classify/reviewList`, data,{
    headers:{
      userInfo:username
    }
  });
};

// 案例后台 案例分类编辑弹窗确定修改接口
export const dealRelInfo = async (data) => {
  return httpRequest.post(`${news_host}/case/classify/dealRelInfo`, data);
};

// 案例后台 批量下架案例
export const deleteBatch = async (data) => {
  return httpRequest.post(`${news_host}/case/manager/deleteBatch`, data);
};

// 案例后台 获取案例审核信息
export const queryCaseInfo = async (data) => {
  return httpRequest.get(`${news_host}/case/manager/queryCaseInfo?caseId=${data.caseId}`, data);
};

// 案例后台 获取分类的共有属性，特有属性
export const queryPropertyList = async (classifyId) => {
  return httpRequest.get(`${news_host}/property/getPropertyList?classifyId=${classifyId}`);
};

// 案例审核删除图片
export const deleteCaseImg = async (data) => {
  return httpRequest.post(`${news_host}/case/manager/deleteCaseImg`, data);
};

// 案例风格列表
export const styleList = async () => {
  return httpRequest.get(`${news_host}/case/style/list`);
};


// 案例后台 查询案例编辑信息
export const queryEditContentInfo = async (caseId) => {
  return httpRequest.get(`${news_host}/case/manager/queryEditContentInfo?caseId=${caseId}`);
};
// 案例后台 保存案例编辑信息
export const updateEditContentInfo = async (data) => {
  const username = localStorage.getItem("username");
  return httpRequest.post(
    `${news_host}/case/manager/updateEditContentInfo`,
    data,
    { headers: { userInfo: username } }
  );
};


// 案例轮播词列表
export const queryCarouselWordsList = async () => {
  return httpRequest.get(`${news_host}/word/queryCarouselWordsList`);
};

// 案例查询轮播词
export const queryCarouselWords = async (data) => {
  return httpRequest.post(`${news_host}/word/queryCarouselWords`, data);
};

// 案例修改轮播词
export const updateCarouselWords = async (data) => {
  return httpRequest.post(`${news_host}/word/updateCarouselWords`, data);
};


// 案例推荐词列表
export const queryRecommendWordsList = async () => {
  return httpRequest.get(`${news_host}/word/queryRecommendWordsList`);
};
// 案例查询推荐词
export const queryRecommendWords = async (data) => {
  return httpRequest.post(`${news_host}/word/queryRecommendWords`, data);
};

// 案例修改推荐词
export const updateRecommendWords = async (data) => {
  return httpRequest.post(`${news_host}/word/updateRecommendWords`, data);
};

// 案例设计师列表
export const desingerList = async () => {
  return httpRequest.get(`${news_host}/designer/list`);
};

// 案例后台，设计师分类、风格、擅长领域集合
export const designerClassifyList = async () => {
  return httpRequest.get(`${news_host}/designer/queryParamList`);
};

// 案例后台 设计师频道列表
export const desingerQueryList = async (data) => {
  return httpRequest.post(`${news_host}/designer/queryList`, data);
};

// 案例后台 设计师上下架
export const designUpOrDown = async (designId, delStatus) => {
  return httpRequest.get(`${news_host}/designer/designUpOrDown?designId=${designId}&delStatus=${delStatus}`);
};

// 案例后台 查询设计师详细信息
export const queryCaseDesignMaster = async (designId) => {
  return httpRequest.get(`${news_host}/designer/queryCaseDesignMaster?designId=${designId}`);
};

// 案例后台 修改设计师
export const updateDesignMaster = async (data) => {
  return httpRequest.post(`${news_host}/designer/updateDesignMaster`, data);
};

// 案例后台 新增设计师
export const addCaseDesignMaster = async (data) => {
  return httpRequest.post(`${news_host}/designer/addCaseDesignMaster`, data);
};
// 案例后台 批量添加大师作品


export const addBatch = async (data) => {
  const username = localStorage.getItem("username");
  return httpRequest.post(`${news_host}/designer/addBatch`, data, { headers: { userInfo: username } });
};

// 案例后台 推荐词列表
export const linkList = async (data) => {
  return httpRequest.post(`${news_host}/link/list`, data);
};

// 案例后台 新增、修改推荐词
export const editLinks = async (data) => {
  return httpRequest.post(`${news_host}/link/editLinks`, data);
};

// 案例后台 推荐词详情
export const linkDetail = async (id) => {
  return httpRequest.get(`${news_host}/link/detail?id=${id}`);
};

// 案例后台 删除推荐词
export const linkDelete = async (id) => {
  return httpRequest.get(`${news_host}/link/delete?id=${id}`);
};

// 案例后台 拓词列表
export const seoList = async (data) => {
  return httpRequest.post(`${news_host}/seo/list`, data);
};
// 案例后台 批量上架拓词
export const seoUploadBatch = async (data) => {
  return httpRequest.post(`${news_host}/seo/uploadBatch`, data);
};

// 案例后台 修改拓词
export const seoUpdate = async (id, searchWord, delStatus) => {
  return httpRequest.get(`${news_host}/seo/update?id=${id}&searchWord=${searchWord}&delStatus=${delStatus}`);
};

// 案例后台 拓词详情
export const setGetDetail = async (id) => {
  return httpRequest.get(`${news_host}/seo/getDetail?id=${id}`);
};

// 案例后台 删除拓词
export const setDelete = async (id) => {
  return httpRequest.get(`${news_host}/seo/delete?id=${id}`);
};


//   案例快速分类审核案例列表
export const doAuditAction = async (data) => {
  return httpRequest.post(`${news_host}/classifyAuditStandard/doAuditAction`, data);
};

// 快速添加案例: 案例快速审核
export const doQuickAuditAction = async (data) => {
  return httpRequest.post(`${news_host}/classifyAuditStandard/doQuickAuditAction`, data);
}

export const queryQuickAuditList = async (data) => {
  return httpRequest.post(`${news_host}/classifyAuditStandard/queryQuickAuditList`, data)
}
// 案例分类审核表格
export const queryAuditList = async (data) => {
  return httpRequest.post(`${news_host}/classifyAuditStandard/queryAuditList`, data);
};
// 案例快速分类审核 弹窗案例详情接口
export const quickClassifydetail = async (caseId) => {
  return httpRequest.get(`${news_host}/case/manager/detail?caseId=${caseId}`);
};

// 灵感审核后台，驳回重申
export const rejectAndReAudit = async (data, header) => {
  return await httpRequest.post(`${linggan_host}/handle/reCheck/batch`, data, {
    headers: { userInfo: header },
  });
};



// 今日推荐 推荐列表
export const fetchRecommendList = async (page, pageSize, recommendType, recommendStatus, orderPutDate, orderOperate, orderClick) => {
  return httpRequest.get(`${linggan_host}/discover/getRecommendList?page=${page}&pageSize=${pageSize}&recommendType=${recommendType}&recommendStatus=${recommendStatus}&orderPutDate=${orderPutDate}&orderOperate=${orderOperate}&orderClick=${orderClick}`);
};

// 创建今日推荐或行业趋势
export const saveRecommendAndTrend = async (data) => {
  return httpRequest.post(`${linggan_host}/discover/saveRecommendAndTrend`, data);
};

// 修改今日推荐或行业趋势
export const modifyRecommendAndTrend = async (data) => {
  return httpRequest.post(`${linggan_host}/discover/modifyRecommendAndTrend`, data);
};

// 修改今日推荐或行业趋势启用状态
export const updateRecommendAndTrendStatus = async (data) => {
  return httpRequest.post(`${linggan_host}/discover/updateRecommendAndTrendStatus`, data);
};

// 案例与灵感推荐列表
export const fetchRecommendCaseAndIns = async (page, pageSize, recommendType) => {
  return httpRequest.get(`${linggan_host}/discover/getRecommendCaseAndIns?page=${page}&pageSize=${pageSize}&recommendType=${recommendType}`);
};

// 通过id获取案例与灵感
export const getRecCaseAndInsById = async (id) => {
  return httpRequest.get(`${linggan_host}/discover/getRecCaseAndInsById?id=${id}`);
};

// 保存后台上传案例与灵感推荐
export const saveCaseRecommend = async (data) => {
  return httpRequest.post(`${linggan_host}/discover/saveCaseRecommend`, data);
};

// 修改后台上传案例与灵感推荐
export const modifyCaseRecommend = async (data) => {
  return httpRequest.post(`${linggan_host}/discover/modifyCaseRecommend`, data);
};

// 他人个人中心灵感集收藏夹列表
export const getAuthorColl = async (page, pageSize, accountId) => {
  return httpRequest.get(`${linggan_host}/discover/getAuthorColl?page=${page}&pageSize=${pageSize}&accountId=${accountId}`);
};

// 获取收藏夹图集详细内容
export const getCollContent = async (collId) => {
  return httpRequest.get(`${linggan_host}/discover/getCollContent?collId=${collId}`);
};

// 获取某个作者用户下的套图
export const getCaseContent = async (page, pageSize, accountId) => {
  return httpRequest.get(`${linggan_host}/discover/getCaseContent?page=${page}&pageSize=${pageSize}&accountId=${accountId}`);
};

// 搜索节点
export const fetchSearchNode = async searchWord => {
  return httpRequest.get(`${linggan_host}/nodeTag/searchNode?searchNodeName=${searchWord}`);
};

// 获取所有节点
export const fetchAllNodes = async (searchWord, nodeTagType) => {
  return httpRequest.get(`${linggan_host}/nodeTag/getAllNodes?searchWord=${searchWord}&nodeTagType=${nodeTagType}`);
};

// 增加节点
export const addNode = async data => {
  return httpRequest.post(`${linggan_host}/nodeTag/addNode`, data);
};

// 节点关系列表
export const fetchNodeRelation = async data => {
  return httpRequest.post(`${linggan_host}/nodeTag/getNodeRelation`, data);
};

// 新增节点关系
export const addNewNodeRelation = async data => {
  return httpRequest.post(`${linggan_host}/nodeTag/addNewNodeRelation`, data);
};

// 删除节点
export const deleteNodeRelation = async data => {
  return httpRequest.post(`${linggan_host}/nodeTag/deleteNodeRelation`, data);
};

// 上传节点管理excel文件
export const uploadNodeTagExcel = () => {
  return `${linggan_host}/nodeTag/uploadNodeTagExcel`
}

// 案例审核下架
export const auditCase = async (data) => {
  const username = localStorage.getItem("username");
  return httpRequest.post(`${news_host}/case/manager/auditCase`, data, { headers: { userInfo: username } });
};


